import useRouter from 'hooks/useRouter';
import MaintainerChargeStationListView from '../../components/MaintainerChargeStationListView';

function MaintainerChargeStationListScreen(props) {
    // ---- PROPERTIES ----
    const router = useRouter();

    return (
        <div className="container-fluid px-4 my-4">
            <MaintainerChargeStationListView />
        </div>
    );
}

export default MaintainerChargeStationListScreen;
